'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind from "./presto.types$-Credential-Kind.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialKind$$anon$45(_$ordinal$28, \u03b4name$28, outer) {
  this.cy2 = 0;
  this.a9x = null;
  this.cy2 = _$ordinal$28;
  this.a9x = \u03b4name$28;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$CredentialKind$$anon$45 as $c_Lpresto_types$CredentialKind$$anon$45 };
$p = $c_Lpresto_types$CredentialKind$$anon$45.prototype = new $j_presto$002etypes$0024$002dCredential$002dKind.$h_Lpresto_types$CredentialKind();
$p.constructor = $c_Lpresto_types$CredentialKind$$anon$45;
/** @constructor */
function $h_Lpresto_types$CredentialKind$$anon$45() {
}
export { $h_Lpresto_types$CredentialKind$$anon$45 as $h_Lpresto_types$CredentialKind$$anon$45 };
$h_Lpresto_types$CredentialKind$$anon$45.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9x;
});
$p.l = (function() {
  return this.a9x;
});
var $d_Lpresto_types$CredentialKind$$anon$45 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialKind$$anon$45, "presto.types$CredentialKind$$anon$45", ({
  YS: 1,
  jy: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$CredentialKind$$anon$45 as $d_Lpresto_types$CredentialKind$$anon$45 };
//# sourceMappingURL=presto.types$-Credential-Kind$$anon$45.js.map
